if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterDOMLoaded);
} else {
    afterDOMLoaded();
}

function afterDOMLoaded() {
  if (document.body.classList.contains('template-product')) {
   try { stickyATCADA();} catch (err) {console.error('error in custom.js, stickyATCADA function. err:', err);}
  }
}

// Add Aria-Labels to Sticky ATC Icons
function stickyATCADA() {
  const variantDropdownSVGs = document.querySelectorAll('div[data-essential-cart-element="variant-select"] div[data-essential-cart-element="icon"] svg');
  if(variantDropdownSVGs) {
    variantDropdownSVGs.forEach(variantDropdownSVG => {
      variantDropdownSVG.setAttribute("aria-label", "Variant Selection Dropdown")
    })
  }

  const quantityLessButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:first-of-type');
  const quantityLessSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"])');
  if (quantityLessButtons && quantityLessSVGs) {
    quantityLessButtons.forEach(quantityLessButton => {
      quantityLessButton.setAttribute("aria-label", "Reduce item quantity by one");
    })
    quantityLessSVGs.forEach(quantityLessSVG => {
      quantityLessSVG.setAttribute("aria-label", "Reduce item quantity by one");
    })
  }

  const quantityMoreButtons = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] button:last-of-type');
  const quantityMoreSVGs = document.querySelectorAll('div[data-essential-cart-element="quantity-select-inner"] div[data-essential-cart-element="icon"] svg:has(path[d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"])');
  if (quantityMoreButtons && quantityMoreSVGs) {
    quantityMoreButtons.forEach(quantityMoreButton => {
      quantityMoreButton.setAttribute("aria-label", "Increase item quantity by one"); 
    })
    quantityMoreSVGs.forEach(quantityMoreSVG => {
      quantityMoreSVG.setAttribute("aria-label", "Increase item quantity by one");
    })
  }
}

// Mouse enter event
document.addEventListener('mouseover', function(event) {
  const megamenuLink = event.target.closest('[data-megamenu-grandlinks]');
  if (megamenuLink) {
    megamenuHover(megamenuLink);
  }
});

function megamenuHover(link) {
  const megamenu = link.closest('.site-nav__megamenu');
  if (!megamenu) return;

  const megamenuGrandLinks = megamenu.querySelectorAll('.site-nav__megamenu-level3');
  megamenuGrandLinks.forEach((megamenuGrandLink) => { megamenuGrandLink.classList.add('hide') });

  document.getElementById(`${link.dataset.megamenuGrandlinks}`).classList.remove('hide');
}

function toggleRichtext(event) {
  if (event.target.classList.contains('is-active')) {
    event.target.classList.remove('is-active');
    event.target.textContent = 'See More';
    event.target.closest('.collection-richtext').classList.remove('is-open');
  } else {
    event.target.classList.add('is-active');
    event.target.textContent = 'See Less';
    event.target.closest('.collection-richtext').classList.add('is-open');
  }
}

function closeNavDrawer() {
  document.body.classList.remove('nav-drawer--opened');
}

function closePredectiveSearch() {
  document.querySelectorAll('.site-header__search-container.is-active').forEach(container => {
    container.classList.remove('is-active', 'is-transitioning');
  });
  document.querySelectorAll('.ss__autocomplete--target').forEach(result => {
    result.style.display = 'none';
  });
  document.querySelector('.predictive-search.is-active')?.close?.();
  document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search', 'js-drawer-closing');
}

function prepareForOffersDrawer() {
  closeNavDrawer();
  closePredectiveSearch();
}

document.addEventListener(
  'click',
  evt => {
    const weeklyTrigger = evt.target.closest('.js-drawer-open-weekly-offers');
    const offersTrigger = evt.target.closest('.js-drawer-open-offers');
    if (!weeklyTrigger && !offersTrigger) return;

    if (weeklyTrigger && theme.OffersDrawer && theme.OffersDrawer.isOpen) {
      theme.OffersDrawer.close();
    }
    if (offersTrigger && theme.WeeklyOffersDrawer && theme.WeeklyOffersDrawer.isOpen) {
      theme.WeeklyOffersDrawer.close();
    }

    prepareForOffersDrawer();
  },
  true
);

function closeAiAssitance() {
  document.body.classList.remove('ai-assistance-opened');
}

document.addEventListener('predictive-search:open', (e) => {
  const mediaQuery = window.matchMedia('(max-width: 989px)');
  if (mediaQuery.matches) {
    closeNavDrawer();
    closeAiAssitance();
  }
});

if (!customElements.get('swiper-component')) {
  customElements.define(
    'swiper-component', 
    class SwiperComponent extends HTMLElement {
      constructor(params) {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      disconnectedCallback() {
        this.slider.destroy();
      }

      initialize() {
        this.sliderEl = this.querySelector('.swiper');
        this.options = JSON.parse(this.querySelector('[data-swiper-options]').textContent);
        
        this.slider = new Swiper(this.sliderEl, this.options);
      }
    }
  );
}

if (!customElements.get('nav-drawer-opener')) {
  customElements.define(
    'nav-drawer-opener', 
    class NavDrawerOpener extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.open.bind(this));
      }

      open() {
        document.body.classList.toggle('nav-drawer--opened');

        const mediaQuery = window.matchMedia('(max-width: 989px)');
        if (mediaQuery.matches) {
          closeAiAssitance();
          closePredectiveSearch();
        }
      }
    }
  )
}

if (!customElements.get('nav-drawer')) {
  customElements.define(
    'nav-drawer', 
    class NavDrawer extends HTMLElement {
      constructor() {
        super();
        
        // Initialize properties
        this.mainNav = null;
        this.subchild = null;
        this.grandchild = null;
        this.currentSubmenu = null;
        this.currentGrandchild = null;
        this.currentLevel1Item = null;
        this.currentLevel2Item = null;
      }

      connectedCallback() {
        this.init();
      }

      isTouchDevice() {
        return window.innerWidth < 990 || window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      }

      init() {
        // Cache DOM elements
        this.mainNav = this.querySelector('.nav-drawer__main-nav');
        this.subchild = this.querySelector('.nav-drawer__subchild');
        this.grandchild = this.querySelector('.nav-drawer__grandchild');
        
        // Get ALL top-level mobile nav links (both with and without data-level attributes)
        const allTopLevelLinks = this.querySelectorAll('.mobile-nav__link--top-level');
        
        allTopLevelLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            if (link.hasAttribute('data-level-1-nav') && this.isTouchDevice()) {
              e.preventDefault();
            }
            if (this.isTouchDevice()) {
              this.handleTopLevelLinkInteraction(link);
            }
          });
          
          link.addEventListener('mouseenter', () => {
            if (!this.isTouchDevice()) {
              this.handleTopLevelLinkInteraction(link);
            }
          });
        });
        
        // Add event listeners for level 2 navigation (within submenus)
        const level2NavItems = this.querySelectorAll('[data-level-2-nav]');
        level2NavItems.forEach(item => {
          item.addEventListener('click', (e) => {
            if (item.hasAttribute('data-level-2-nav') && this.isTouchDevice()) {
              e.preventDefault();
            }
            if (this.isTouchDevice()) {
              this.handleSubmenuInteraction(item);
            }
          });
          
          item.addEventListener('mouseenter', () => {
            if (!this.isTouchDevice()) {
              this.handleSubmenuInteraction(item);
            }
          });
        });
        
        // Add event listeners for back buttons
        this.addBackButtonListeners();
        
        // Add mouse events to subchild container
        if (this.subchild) {
          this.subchild.addEventListener('mouseenter', () => {
            // Keep submenu open when mouse enters it
          });
          
          this.subchild.addEventListener('mouseleave', (e) => {
            // Only close submenu if moving to a DIFFERENT top-level link
            const targetTopLevelLink = e.relatedTarget && 
              e.relatedTarget.closest('.mobile-nav__link--top-level');
            
            if (targetTopLevelLink) {
              // Check if it's the SAME link that opened this submenu
              const isSameLink = targetTopLevelLink === this.currentLevel1Item;
              
              // Only close if it's a DIFFERENT link
              if (!isSameLink) {
                this.closeAllSubmenus();
              }
            }
          });
        }
        
        // Add mouse events to grandchild container
        if (this.grandchild) {
          this.grandchild.addEventListener('mouseenter', () => {
            // Keep grandchild open when mouse enters it
          });
          
          this.grandchild.addEventListener('mouseleave', (e) => {
            // Only close grandchild if moving to a DIFFERENT level 2 link
            const targetLevel2Link = e.relatedTarget && 
              e.relatedTarget.closest('[data-level-2-nav]');
            
            if (targetLevel2Link) {
              // Check if it's the SAME link that opened this grandchild
              const isSameLink = targetLevel2Link === this.currentLevel2Item;
              
              // Only close if it's a DIFFERENT link
              if (!isSameLink) {
                this.closeAllGrandchildMenus();
              }
            }
          });
        }
        
        // Add click outside listener
        document.addEventListener('click', (e) => {
          this.handleClickOutside(e);
        });
        
        // Close button functionality
        const closeMask = this.querySelector('.nav-drawer__mask');
        if (closeMask) {
          closeMask.addEventListener('click', (event) => {
            document.body.classList.remove('nav-drawer--opened');
            this.closeAllMenus();
          });
        }
      }
      
      addBackButtonListeners() {
        // Add click listeners to all back buttons
        const backButtons = this.querySelectorAll('.mobile-nav__back-button');
        backButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleBackButtonClick(button);
          });
        });
      }
      
      handleBackButtonClick(button) {
        // Determine which back button was clicked based on its location
        const isInGrandchild = button.closest('.nav-drawer__grandchild');
        
        if (isInGrandchild) {
          // Back from grandchild to subchild
          this.closeAllGrandchildMenus();
        } else {
          // Back from subchild to main nav - just close submenu
          this.closeAllSubmenus();
        }
      }
      
      handleTopLevelLinkInteraction(link) {
        // Check if this link has a data-level-1-nav attribute
        const hasDataLevel1Nav = link.hasAttribute('data-level-1-nav');
        
        if (hasDataLevel1Nav) {
          // Handle links WITH data-level-1-nav
          const targetId = link.getAttribute('data-level-1-nav');
          const targetSubmenu = this.querySelector(`#${targetId}`);
          
          if (!targetSubmenu || !this.subchild) return;
          
          // Check if this is the SAME link that already has its dropdown open
          const isSameLink = this.currentLevel1Item === link;
          const isDropdownOpen = this.subchild.classList.contains('is-open');
          
          // If this is the SAME link AND dropdown is already open, DO NOTHING
          // This prevents toggling when re-hovering the same link
          if (isSameLink && isDropdownOpen) {
            return; // Keep dropdown open, don't close it
          }
          
          // Check if it's a different menu (different target submenu)
          const isSameMenu = this.currentSubmenu === targetSubmenu;
          
          // Close all submenus if it's a different menu (different data-level-1-nav)
          if (!isSameMenu) {
            this.closeAllSubmenus();
          }
          
          // Open the target submenu
          this.subchild.classList.add('is-open');
          targetSubmenu.classList.remove('hide');
          
          // Store reference to currently open submenu
          this.currentSubmenu = targetSubmenu;
          this.currentLevel1Item = link;
          
          // Close any open grandchild menu when opening a new level 1 menu
          this.closeAllGrandchildMenus();
        } else {
          // Handle links WITHOUT data-level-1-nav (like Home, Stores, etc.)
          // These should close all dropdowns
          this.closeAllMenus();
        }
      }
      
      handleSubmenuInteraction(item) {
        const targetId = item.getAttribute('data-level-2-nav');
        const targetGrandchild = this.querySelector(`#${targetId}`);
        
        if (!targetGrandchild || !this.grandchild) return;
        
        // Check if this is the SAME link that already has its grandchild open
        const isSameLink = this.currentLevel2Item === item;
        const isGrandchildOpen = this.grandchild.classList.contains('is-open');
        
        // If this is the SAME link AND grandchild is already open, DO NOTHING
        if (isSameLink && isGrandchildOpen) {
          return; // Keep grandchild open, don't close it
        }
        
        // Check if it's a different menu (different target grandchild)
        const isSameMenu = this.currentGrandchild === targetGrandchild;
        
        // Close all grandchild menus if it's a different menu
        if (!isSameMenu) {
          this.closeAllGrandchildMenus();
        }
        
        // Open the target grandchild menu
        this.grandchild.classList.add('is-open');
        targetGrandchild.classList.remove('hide');
        
        // Store reference to currently open grandchild menu
        this.currentGrandchild = targetGrandchild;
        this.currentLevel2Item = item;
        
        // Ensure parent submenu stays open and visible
        if (this.currentSubmenu && this.subchild) {
          this.currentSubmenu.classList.remove('hide');
          this.subchild.classList.add('is-open');
        }
      }
      
      handleClickOutside(e) {
        // Close menus only if clicking outside the drawer AND not on any menu-related element
        if (!this.contains(e.target) && 
            !e.target.closest('[data-drawer-toggle]') &&
            !e.target.closest('.nav-drawer__subchild') &&
            !e.target.closest('.nav-drawer__grandchild')) {
          this.closeAllMenus();
        }
      }
      
      closeAllSubmenus() {
        if (!this.subchild) return;
        
        // Close all child-nav menus
        const allChildNavs = this.subchild.querySelectorAll('.nav-drawer__child-nav, .nav-drawer__collections');
        allChildNavs.forEach(menu => {
          menu.classList.add('hide');
        });
        
        this.subchild.classList.remove('is-open');
        this.currentSubmenu = null;
        this.currentLevel1Item = null;
        
        // Also close grandchild menus
        this.closeAllGrandchildMenus();
      }
      
      closeAllGrandchildMenus() {
        if (!this.grandchild) return;
        
        // Close all grandchild-nav menus
        const allGrandchildMenus = this.grandchild.querySelectorAll('.nav-drawer__grandchild-nav');
        allGrandchildMenus.forEach(menu => {
          menu.classList.add('hide');
        });
        this.grandchild.classList.remove('is-open');
        this.currentGrandchild = null;
        this.currentLevel2Item = null;
      }
      
      closeAllMenus() {
        this.closeAllSubmenus();
        this.closeAllGrandchildMenus();
      }
      
      disconnectedCallback() {
        // Clean up if needed
      }
    }
  );
}

if (!customElements.get('section-tabs')) {
  customElements.define(
    'section-tabs',
    class SectionTabs extends HTMLElement {
      constructor() {
        super();

        this.tabs = Array.from(this.querySelectorAll('.section-tab'));
        this.contents = Array.from(this.querySelectorAll('.section-tabs-content'));
        this.linkTargets = Array.from(this.querySelectorAll('[data-tab-link]'));
        this.tabContainer = this.querySelector('.section-tabs__inner');
      }

      connectedCallback() {
        if (!this.tabs.length || !this.contents.length) return;
        this.init();
      }

      init() {
        this.tabs.forEach(tab =>
          tab.addEventListener('click', () => this.onTabClick(tab))
        );

        if (this.classList.contains('offers-page__tabs')) {
          const activeTab = this.querySelector('.section-tab.active');
          if (activeTab) this.filterOfferProducts(activeTab.dataset.id);
        }
      }

      filterOfferProducts(activeTabId) {
        const grid = this.querySelector('.offers-page__products-grid');
        if (!grid) return;

        let visibleCount = 0;

        grid.querySelectorAll('.offers-page__product').forEach(item => {
          const tabs = (item.dataset.offerTabs || '')
            .trim()
            .split(/\s+/)
            .filter(Boolean);
          const show = activeTabId === 'offer-all' || tabs.includes(activeTabId);

          item.classList.toggle('is-offer-hidden', !show);
          item.toggleAttribute('hidden', !show);
          if (show) visibleCount += 1;
        });

        const emptyMessage = this.querySelector('.offers-page__products-empty');
        if (emptyMessage) {
          emptyMessage.hidden = visibleCount > 0;
        }
      }

      onTabClick(activeTab) {
        const { id, url } = activeTab.dataset;

        this.tabs.forEach(tab => {
          const isActive = tab === activeTab;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.contents.forEach(content => {
          const isVisible = content.id === id;
          content.classList.toggle('is-visible', isVisible);
          if (isVisible) {
            content.removeAttribute('hidden');
          } else {
            content.setAttribute('hidden', '');
          }
        });

        this.scrollTabToLeft(activeTab);

        if (url) this.updateLink(url);

        if (this.classList.contains('offers-page__tabs')) {
          this.filterOfferProducts(id);
        }

        if (this.classList.contains('offers-page__tabs') && id) {
          const baseUrl = `${window.location.pathname}${window.location.search}`;
          if (id === 'offer-all') {
            history.replaceState(null, '', baseUrl);
          } else {
            history.replaceState(null, '', `${baseUrl}#${id}`);
          }
        }
      }

      scrollTabToLeft(activeTab) {
        if (!this.tabContainer) return;

        activeTab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      updateLink(url) {
        this.linkTargets.forEach(link => {
          link.href = url;
        });
      }
    }
  );

  const activateOffersPageTabFromHash = () => {
    document.querySelectorAll('.offers-page section-tabs').forEach(tabsEl => {
      const hash = window.location.hash.replace(/^#/, '');
      const offerParam = new URLSearchParams(window.location.search).get('offer');
      let targetId = 'offer-all';

      if (hash) {
        targetId = hash;
      } else if (offerParam) {
        targetId = offerParam.startsWith('offer-') ? offerParam : `offer-${offerParam}`;
      }

      const tab =
        Array.from(tabsEl.querySelectorAll('.section-tab')).find(el => el.dataset.id === targetId) ||
        tabsEl.querySelector('.section-tab[data-id="offer-all"]');
      if (tab) tab.click();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateOffersPageTabFromHash);
  } else {
    activateOffersPageTabFromHash();
  }

  window.addEventListener('hashchange', activateOffersPageTabFromHash);
}

if (!customElements.get('logo-bar')) {
  customElements.define(
    'logo-bar', 
    class LogoBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.cloneListElement();
      }

      cloneListElement() {
        const listElement = this.querySelector('.logo-bar__list');
        if (!listElement) return;
        
        const clone = listElement.cloneNode(true);
        listElement.after(clone);
      }
    }
  );
}

function openMediaModal() {
  const mediaModal = document.getElementById('ProductMediaModal');
  if (!mediaModal) return;

  mediaModal.openModal();
}

class ShopByReel extends HTMLElement {
  constructor() {
    super();

    this.isMediaLazyLoaded = false;
    this.isMuted = true;

    this.items = this.querySelectorAll('.shop-reel__item');
    this.modal = this.querySelector('.shop-reel__modal');
    this.volumeButton = this.querySelector('.shop-reel__volume');

    this.slider = this.querySelector('.shop-reel__modal__slider');
    this.slides = this.querySelectorAll('.shop-reel__modal__slide');
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
    this.handleClickEvents();
  }

  lazyLoadMedia() {
    if (this.isMediaLazyLoaded) return;
    this.isMediaLazyLoaded = true;

    // Load videos
    const videoElements = this.modal.querySelectorAll('video');
    videoElements.forEach(video => {
      Array.from(video.children).forEach(source => {
        if (source.tagName === 'SOURCE' && source.dataset.src) {
          source.src = source.dataset.src;
        }
      });
      video.load();
      video.muted = false;
    });

    // Load images
    const lazyImages = this.modal.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    });
  }

  handleClickEvents() {
    this.addEventListener('click', (event) => {
      const item = event.target.closest('.shop-reel__item.has-product');
      if (item) {
        this.openModal(item);
        return;
      }

      const closeButton = event.target.closest('.shop-reel__modal__close');
      if (closeButton || event.target.classList.contains('shop-reel__modal')) {
        this.closeModal();
        return;
      }

      const volumeButton = event.target.closest('.shop-reel__volume');
      if (volumeButton) {
        this.toggleVolume(volumeButton);
        return;
      }

      const addCartButton = event.target.closest('[data-add-cart]');
      if (addCartButton) {
        event.preventDefault();
        this.addItemToCart(addCartButton);
      }
    });
  }

  initSlider() {
    const sliderArgs = {
      wrapAround: this.slides.length > 3,
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
    };

    this.flickity = new theme.Slideshow(this.slider, sliderArgs);

    this.flickity.slideshow.on( 'change', (index) => {
      this.playActiveVideo(index);
      this.flickity.goToSlide(index);
    });
  }

  openModal(item) {
    this.lazyLoadMedia();
    this.playActiveVideo(item.dataset.index);
    this.flickity.goToSlide(item.dataset.index);

    document.documentElement.classList.add('overflow-hidden');
    this.modal.classList.add('open');
  }

  closeModal() {
    this.pauseAllVideos();

    document.documentElement.classList.remove('overflow-hidden');
    this.modal.classList.remove('open');
    this.volumeButton.classList.remove('muted');
  }

  playActiveVideo(currentIndex) {
    this.querySelectorAll('.shop-reel__modal__slide').forEach((slide, slideIndex) => {
      const videoElement = slide.querySelector('video');
      if (!videoElement) return;

      if (slideIndex == currentIndex) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    });
  }

  pauseAllVideos() {
    this.querySelectorAll('.shop-reel__modal__slide').forEach(slide => {
      const videoElement = slide.querySelector('video');
      if (!videoElement) return;

      videoElement.pause();
    });
  }

  toggleVolume(volumeButton) {
    const video = volumeButton.closest('.shop-reel__modal__slide').querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    volumeButton.classList.toggle('muted', video.muted);
  }

  addItemToCart(addCartButton) {
    const productFormButton = document.querySelector('.product-section .product-single__form [data-add-to-cart]');
    if (!productFormButton) return;

    productFormButton.click();
  }
}

if (!customElements.get('shop-by-reel')) {
  customElements.define('shop-by-reel', ShopByReel);
}

class ProductMediaModal extends HTMLElement {
  constructor() {
    super();

    this.isMediaLazyLoaded = false;
    
    // Cache DOM elements
    this.tabButtons = this.querySelectorAll('[data-tab]');
    this.tabPanels = this.querySelectorAll('[data-tab-content]');
    this.mediaImages = this.querySelectorAll('[data-image]');
    this.imageThumbnails = this.querySelectorAll('[data-image-thumb]');
    this.mediaVideos = this.querySelectorAll('[data-video]');
    this.videoThumbnails = this.querySelectorAll('[data-video-thumb]');
    
    // Bind methods
    this.handleModalInteraction = this.handleModalInteraction.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  connectedCallback() {
    this.initializeEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleModalInteraction);
  }

  initializeEventListeners() {
    this.addEventListener('click', this.handleModalInteraction);
  }

  handleModalInteraction(event) {
    const target = event.target;
    const tabButton = target.closest('[data-tab]');
    
    if (tabButton) {
      this.switchActiveTab(tabButton);
      return;
    }

    const closeButton = target.closest('.product-media-modal__close');
    if (closeButton || target.classList.contains('product-media-modal')) {
      this.closeModal();
      return;
    }

    const imageThumbnail = target.closest('[data-image-thumb]');
    if (imageThumbnail) {
      this.showImage(imageThumbnail.dataset.index);
      return;
    }

    const videoThumbnail = target.closest('[data-video-thumb]');
    if (videoThumbnail) {
      this.showVideo(videoThumbnail.dataset.index);
    }
  }

  lazyLoadMedia() {
    if (this.isMediaLazyLoaded) return;
    this.isMediaLazyLoaded = true;

    // Load videos
    const videoElements = this.querySelectorAll('video');
    videoElements.forEach(video => {
      Array.from(video.children).forEach(source => {
        if (source.tagName === 'SOURCE' && source.dataset.src) {
          source.src = source.dataset.src;
        }
      });
      video.load();
      video.muted = false;
    });

    // Load images
    const lazyImages = this.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    });
  }

  switchActiveTab(selectedTab) {
    // Update active tab
    this.tabButtons.forEach(tab => tab.classList.remove('is-active'));
    selectedTab.classList.add('is-active');

    // Show corresponding content
    this.tabPanels.forEach(panel => panel.classList.add('hide'));
    this.querySelector(`#MediaModal-${selectedTab.dataset.id}`).classList.remove('hide');

    // Handle media playback
    if (selectedTab.dataset.tab === 'videos') {
      this.playActiveVideo();
    } else {
      this.pauseAllVideos();
    }
  }

  showImage(imageIndex) {
    this.mediaImages.forEach(img => {
      img.classList.toggle('hide', imageIndex != img.dataset.index);
    });
    
    this.imageThumbnails.forEach(thumb => {
      thumb.classList.toggle('active', imageIndex == thumb.dataset.index);
    });
  }

  showVideo(videoIndex) {
    this.mediaVideos.forEach(video => {
      const videoElement = video.querySelector('video');
      if (videoIndex == video.dataset.index) {
        video.classList.remove('hide');
        videoElement.play();
      } else {
        video.classList.add('hide');
        videoElement.pause();
      }
    });
  }

  playActiveVideo() {
    this.mediaVideos.forEach(video => {
      const videoElement = video.querySelector('video');
      if (!video.classList.contains('hide')) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    });
  }

  pauseAllVideos() {
    this.mediaVideos.forEach(video => {
      video.querySelector('video').pause();
    });
  }

  getCurrentMediaIndex() {
    const slider = document.querySelector('[data-product-photos]');
    const flickity = slider ? Flickity.data(slider) : null;
    return flickity ? flickity.selectedIndex : 0;
  }

  displayCurrentMedia() {
    const currentIndex = this.getCurrentMediaIndex();
    const isVideo = Array.from(this.mediaVideos).some(
      video => video.dataset.index == currentIndex
    );

    if (isVideo) {
      this.querySelector('[data-tab="videos"]')?.click();
      this.showVideo(currentIndex);
    } else {
      this.querySelector('[data-tab="images"]')?.click();
      this.showImage(currentIndex);
    }
  }

  openModal() {
    this.lazyLoadMedia();
    this.displayCurrentMedia();

    requestAnimationFrame(() => {
      document.documentElement.classList.add('overflow-hidden');
      this.classList.add('open');
    });
  }

  closeModal() {
    this.pauseAllVideos();
    document.documentElement.classList.remove('overflow-hidden');
    this.classList.remove('open');
  }
}

if (!customElements.get('product-media-modal')) {
  customElements.define('product-media-modal', ProductMediaModal);
}

class AiAssistanceOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.open.bind(this));
  }

  open() {
    const aiAssistance = document.querySelector('ai-assistance');
    aiAssistance?.open();
  }
}

if (!customElements.get('ai-assistance-opener')) {
  customElements.define('ai-assistance-opener', AiAssistanceOpener);
}


class AiAssistance extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[data-ai-input]');
    this.input?.addEventListener('input', this.onInputChange.bind(this));

    this.closeEl = this.querySelector('.ai-assistance__close');
    this.closeEl?.addEventListener('click', this.close.bind(this));

    this.mask = this.querySelector('.ai-assistance__mask');
    this.mask?.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
  }

  onInputChange() {
    const inputValue = this.input.value.trim();
    this.classList.toggle('ai-initialized', inputValue.length);
  }

  open() {
    document.body.classList.add('ai-assistance-opened');

    const mediaQuery = window.matchMedia('(max-width: 989px)');
    if (mediaQuery.matches) {
      closeNavDrawer();
      closePredectiveSearch();
    }
  }

  close() {
    document.body.classList.remove('ai-assistance-opened');
  }
}

if (!customElements.get('ai-assistance')) {
  customElements.define('ai-assistance', AiAssistance);
}

class AutoExpandTextarea extends HTMLElement {
  constructor() {
    super();

    this.textarea = this.querySelector('textarea');
    this.initialHeight = parseInt(this.textarea.dataset.height) || 160; // Height when user starts typing
    this.maxHeight = parseInt(this.textarea.dataset.maxHeight) || 240;
    this.minHeight = parseInt(this.textarea.dataset.minHeight) || 48;
    
    this.init();
  }

  init() {
    // Set initial styles
    this.textarea.style.height = `${this.minHeight}px`;
    this.textarea.style.minHeight = `${this.minHeight}px`;
    this.textarea.style.maxHeight = `${this.maxHeight}px`;
    this.textarea.style.overflowY = 'hidden';
    this.textarea.style.resize = 'none';
    
    // Track if user has typed
    this.hasTyped = false;
    
    // Add event listener
    this.textarea.addEventListener('input', () => this.adjustHeight());
  }

  adjustHeight() {
    const hasContent = this.textarea.value.length > 0;
    
    // If no content, reset to min height
    if (!hasContent) {
      this.hasTyped = false;
      this.textarea.style.height = `${this.minHeight}px`;
      this.textarea.style.overflowY = 'hidden';
      return;
    }
    
    // If this is the first time user types
    if (!this.hasTyped) {
      this.hasTyped = true;
      // Set to initial height (200px)
      this.textarea.style.height = `${this.initialHeight}px`;
      this.textarea.style.overflowY = 'auto';
    } else {
      // User has already typed before, adjust based on content
      
      // Temporarily set height to auto to get accurate scrollHeight
      this.textarea.style.height = 'auto';
      
      // Get the scroll height (actual content height)
      const scrollHeight = this.textarea.scrollHeight;
      
      // Calculate the target height
      let targetHeight;
      
      if (scrollHeight <= this.initialHeight) {
        // Content fits within initial height
        targetHeight = this.initialHeight;
      } else {
        // Content exceeds initial height, use scrollHeight but cap at maxHeight
        targetHeight = Math.min(scrollHeight, this.maxHeight);
      }
      
      // Apply the calculated height
      this.textarea.style.height = `${targetHeight}px`;
      
      // Show scrollbar only if content exceeds maxHeight
      this.textarea.style.overflowY = scrollHeight > this.maxHeight ? 'auto' : 'hidden';
    }
  }

  reset() {
    this.textarea.value = '';
    this.hasTyped = false;
    this.textarea.style.height = `${this.minHeight}px`;
    this.textarea.style.overflowY = 'hidden';
  }
}

if (!customElements.get('auto-expand-textarea')) {
  customElements.define('auto-expand-textarea', AutoExpandTextarea);
}

/**
 * FlyToCart custom element for animating product images to cart
 * This component creates a visual effect of a product "flying" to the cart when added
 */
class FlyToCart extends HTMLElement {
  /** @type {Element} */
  source;

  /** @type {boolean} */
  useSourceSize = false;

  /** @type {Element} */
  destination;

  // No connectedCallback — animation is triggered manually
  play = async () => {
    const sourceRect = this.source.getBoundingClientRect();
    const destinationRect = this.destination.getBoundingClientRect();

    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2,
      y: sourceRect.top + sourceRect.height / 2,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2,
      y: destinationRect.top + destinationRect.height / 2,
    };

    if (this.useSourceSize) {
      this.style.setProperty('--width', `${sourceRect.width}px`);
      this.style.setProperty('--height', `${sourceRect.height}px`);
    }

    this.style.setProperty('--start-x', `${startPoint.x}px`);
    this.style.setProperty('--start-y', `${startPoint.y}px`);
    this.style.setProperty('--travel-x', `${endPoint.x - startPoint.x}px`);
    this.style.setProperty('--travel-y', `${endPoint.y - startPoint.y}px`);

    // Force a reflow so the browser registers the properties before animating
    void this.offsetWidth;

    // Now kick off the animation by adding a class
    this.classList.add('is-animating');

    await Promise.allSettled(this.getAnimations().map((a) => a.finished));
    this.remove();
  };
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}


class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.cartItemKey = null;
    this.qtyUpdateTimer = null;
    this.isUpdating = false;
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('[data-add-to-cart]');
    this.submitBtnText = this.querySelector('[data-add-to-cart-text]');
    this.qtyWrapper = this.querySelector('.js-qty__wrapper');
    this.qtyInput = this.querySelector('.js-qty__num');
    this.qtyPlus = this.querySelector('.js-qty__adjust--plus');
    this.qtyMinus = this.querySelector('.js-qty__adjust--minus');

    this.variantRadios = this.querySelectorAll('input[type="radio"][name="id"]');
    this.variantId = this.getSelectedVariantId();

    if (this.dataset.key) {
      this.cartItemKey = this.dataset.key;
    }

    if (this.form) {
      new theme.AjaxProduct(this.form, '[data-add-to-cart]');
      this.form.addEventListener('ajaxProduct:added', this.onAdded.bind(this));
      this.form.addEventListener('ajaxProduct:error', this.onError.bind(this));
    }

    if (this.variantRadios.length) {
      this.variantRadios.forEach((radio) => {
        radio.addEventListener('change', this.onVariantChange.bind(this));
      });

      let checkedRadio = this.querySelector('input[type="radio"][name="id"]:checked');

      // If the preselected size is sold out, switch to the first available one
      if (checkedRadio && checkedRadio.getAttribute('data-available') !== 'true') {
        const firstAvailable = Array.from(this.variantRadios).find(
          (radio) => radio.getAttribute('data-available') === 'true' && !radio.disabled
        );
        if (firstAvailable) {
          checkedRadio.checked = false;
          firstAvailable.checked = true;
          checkedRadio = firstAvailable;
        }
      }

      if (checkedRadio) {
        this.variantId = this.getSelectedVariantId();
        this.updateMaxFromRadio(checkedRadio);
        this.updateAvailabilityFromRadio(checkedRadio);
        this.updatePrice(checkedRadio);
      }
    }

    this.setupQtyButtons();

    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated.bind(this));
  }

  getSelectedVariantId() {
    if (this.variantRadios && this.variantRadios.length) {
      const checked = this.querySelector('input[type="radio"][name="id"]:checked');
      return checked ? checked.value : null;
    }

    return this.querySelector('input[type="hidden"][name="id"]')?.value || null;
  }

  getMatchingCartItems(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.filter((item) => (
      String(item.variant_id) === String(this.variantId) || String(item.id) === String(this.variantId)
    ));
  }

  syncFromCart(cart) {
    const matchingItems = this.getMatchingCartItems(cart);
    const totalQty = matchingItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

    if (totalQty > 0) {
      this.cartItemKey = matchingItems[0].key;
      this.dataset.key = matchingItems[0].key;

      if (this.qtyInput) {
        this.qtyInput.value = totalQty;
      }

      this.showQtyPicker();
      return true;
    }

    this.cartItemKey = null;
    this.dataset.key = '';
    this.hideQtyPicker();
    return false;
  }

  getMaxQty() {
    const max = parseInt(this.qtyInput.getAttribute('max'), 10);
    return !isNaN(max) && max > 0 ? max : null;
  }

  getItemLabel() {
    const productTitle =
      this.dataset.productTitle ||
      this.closest('[data-product-title]')?.getAttribute('data-product-title') ||
      '';

    const checked = this.querySelector('input[type="radio"][name="id"]:checked');
    let variantTitle = checked?.getAttribute('data-variant-title') || '';
    if (variantTitle === 'Default Title') variantTitle = '';

    if (productTitle && variantTitle) {
      return `${productTitle} - ${variantTitle}`;
    }

    return productTitle || variantTitle;
  }

  getMaxQuantityMessage(max) {
    const template = theme.strings.maxQuantity || 'You can only have [quantity] of [title] in your cart.';
    return template.replace('[quantity]', max).replace('[title]', this.getItemLabel());
  }

  updateMaxFromRadio(radio) {
    if (!this.qtyInput) return;

    const limits = [];
    const offerMax = parseInt(this.dataset.offerMax, 10);
    if (!isNaN(offerMax) && offerMax > 0) {
      limits.push(offerMax);
    }

    if (radio) {
      const maxAttr = radio.getAttribute('data-max');
      if (maxAttr !== null && maxAttr !== '') {
        const max = parseInt(maxAttr, 10);
        if (!isNaN(max)) {
          limits.push(max);
        }
      }
    }

    if (!limits.length) {
      this.qtyInput.removeAttribute('max');
      return;
    }

    const max = Math.min(...limits);
    this.qtyInput.setAttribute('max', String(max));
    const current = parseInt(this.qtyInput.value, 10) || 1;
    if (max > 0 && current > max) {
      this.qtyInput.value = max;
    }
  }

  updateAvailabilityFromRadio(radio) {
    if (!radio) return;

    const available = radio.getAttribute('data-available') === 'true';
    const soldOutText = theme.strings.soldOut || 'Sold Out';
    const defaultText = this.submitBtnText?.dataset.defaultText || 'Add to cart';

    if (this.submitBtn) {
      this.submitBtn.disabled = !available;
      if (available) {
        this.submitBtn.removeAttribute('disabled');
        this.submitBtn.classList.remove('disabled');
      } else {
        this.submitBtn.setAttribute('disabled', 'disabled');
        this.submitBtn.classList.add('disabled');
      }
    }

    if (this.submitBtnText) {
      this.submitBtnText.textContent = available ? defaultText : soldOutText;
    }

    const gridContent = this.closest('.grid-product__content');
    const badges = gridContent?.querySelector('.grid-product__badges');
    if (!badges) return;

    let outStock = badges.querySelector('.label.out-stock');
    if (!available) {
      if (!outStock) {
        outStock = document.createElement('span');
        outStock.className = 'label out-stock';
        outStock.innerHTML = '<strong>Out stock</strong>';
        badges.prepend(outStock);
      }
    } else if (outStock) {
      outStock.remove();
    }
  }

  updatePrice(radio) {
    const price = parseInt(radio.dataset.price, 10);
    const comparePrice = parseInt(radio.dataset.comparePrice, 10);

    // Price element lives outside <product-form>, inside the anchor tag above it
    const gridContent = this.closest('.grid-product__content');
    if (!gridContent) return;

    const priceEl = gridContent.querySelector('.grid-product__price--sale');
    const originalPriceEl = gridContent.querySelector('.grid-product__price--original');

    if (priceEl && !isNaN(price)) {
      priceEl.textContent = theme.Currency.formatMoney(price, theme.settings.moneyFormat).replace(/\.00$/, '');
    }

    if (originalPriceEl) {
      if (!isNaN(comparePrice) && comparePrice > price) {
        originalPriceEl.textContent = theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat).replace(/\.00$/, '');
        originalPriceEl.classList.remove('hide');
      } else {
        originalPriceEl.textContent = '';
        originalPriceEl.classList.add('hide');
      }
    }

    const savingEl = gridContent.querySelector('.grid-product__saving');
    const savingAmountEl = gridContent.querySelector('.grid-product__saving-amount');
    if (savingEl) {
      if (!isNaN(comparePrice) && comparePrice > price) {
        const saved = Math.round(((comparePrice - price) * 100) / comparePrice);
        if (savingAmountEl) savingAmountEl.textContent = `Save ${saved}%`;
        savingEl.classList.remove('hide');
      } else {
        savingEl.classList.add('hide');
      }
    }
  }

  onVariantChange(evt) {
    this.cartItemKey = null;
    this.dataset.key = '';
    this.isUpdating = false;
    clearTimeout(this.qtyUpdateTimer);

    this.variantId = this.getSelectedVariantId();

    // Update price, max, and sold-out state from the selected radio
    if (evt && evt.target) {
      this.updatePrice(evt.target);
      this.updateMaxFromRadio(evt.target);
      this.updateAvailabilityFromRadio(evt.target);
    }

    theme.cart.getCart()
    .then((cart) => {
      if (!cart || !Array.isArray(cart.items)) {
        this.hideQtyPicker();
        return;
      }

      this.syncFromCart(cart);
    })
    .catch((err) => {
      console.log('[onVariantChange] Failed to fetch cart:', err);
      this.hideQtyPicker(); // Fail safe: hide picker rather than show stale state
    });
  }

  onCartUpdated(evt) {
    if (this.isUpdating) return;

    const cart = evt.detail.cart;
    if (!cart || !cart.items) return;

    this.syncFromCart(cart);
  }

  setupQtyButtons() {
    if (this.qtyPlus) {
      this.qtyPlus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(this.qtyInput.value, 10) || 1;
        const max = this.getMaxQty();

        if (max !== null && current >= max) {
          alert(this.getMaxQuantityMessage(max));
          return;
        }

        this.setQty(current + 1);
      });
    }

    if (this.qtyMinus) {
      this.qtyMinus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(this.qtyInput.value, 10) || 1;
        this.setQty(current - 1);
      });
    }

    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', () => {
        const val = parseInt(this.qtyInput.value, 10);
        const max = this.getMaxQty();

        if (max !== null && val > max) {
          alert(this.getMaxQuantityMessage(max));
          this.setQty(max);
          return;
        }

        this.setQty(isNaN(val) ? 1 : val);
      });
    }
  }

  setQty(qty) {
    this.qtyInput.value = qty;
    clearTimeout(this.qtyUpdateTimer);

    this.qtyUpdateTimer = setTimeout(() => {
      this.qtyWrapper.classList.add('is-loading');
      this.isUpdating = true;

      theme.cart.getCart()
        .then((cart) => {
          const matchingItems = this.getMatchingCartItems(cart);
          if (!matchingItems.length) {
            this.hideQtyPicker();
            return null;
          }

          const updates = {};
          matchingItems.forEach((item, index) => {
            updates[item.key] = index === 0 ? Math.max(qty, 0) : 0;
          });

          return theme.cart.updateItems(updates);
        })
        .then((cartResponse) => {
          if (!cartResponse) return;

          const cart = JSON.parse(cartResponse);
          this.syncFromCart(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch((err) => {
          console.warn('Cart update error:', err);
        })
        .finally(() => {
          this.qtyWrapper.classList.remove('is-loading');
          this.isUpdating = false;
        });
    }, 300);
  }

  flyProductToCart() {
    const image = this.dataset.productVariantMedia;
    const cartIcon = document.querySelector('.site-nav__icons .js-drawer-open-cart');

    if (!image || !cartIcon) return;

    const flyToCartElement = document.createElement('fly-to-cart');
    flyToCartElement.classList.add('fly-to-cart--quick');
    flyToCartElement.style.setProperty('background-image', `url(${image})`);
    flyToCartElement.style.setProperty('--start-opacity', '0');

    const sourceRect = this.submitBtn.getBoundingClientRect();
    const destinationRect = cartIcon.getBoundingClientRect();

    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2,
      y: sourceRect.top + sourceRect.height / 2,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2,
      y: destinationRect.top + destinationRect.height / 2,
    };

    flyToCartElement.style.setProperty('--start-x', `${startPoint.x}px`);
    flyToCartElement.style.setProperty('--start-y', `${startPoint.y}px`);
    flyToCartElement.style.setProperty('--travel-x', `${endPoint.x - startPoint.x}px`);
    flyToCartElement.style.setProperty('--travel-y', `${endPoint.y - startPoint.y}px`);

    flyToCartElement.source = this.submitBtn;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);

    setTimeout(() => {
      flyToCartElement.play();
    }, 250);
  }

  onAdded(evt) {
    const isFirstAdd = this.dataset.inCart !== 'true';
    const product = evt.detail.product;
    this.cartItemKey = product.key;
    this.dataset.key = product.key;

    if (isFirstAdd) {
      this.dataset.openDrawer = 'true';
    }

    this.variantId = this.getSelectedVariantId();

    this.flyProductToCart();

    this.isUpdating = true;
    this.showQtyPicker();

    theme.cart.getCart().then((cart) => {
      this.syncFromCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).finally(() => {
      this.isUpdating = false;
    });
  }

  onError(evt) {
    console.warn('Add to cart error:', evt.detail.errorMessage);

    if (this.submitBtn) {
      this.submitBtn.classList.remove('btn--loading');
      this.submitBtn.disabled = false;
    }
  }

  removeFromCart() {
    theme.cart.getCart()
      .then((cart) => {
        const matchingItems = this.getMatchingCartItems(cart);
        if (!matchingItems.length) {
          this.cartItemKey = null;
          this.dataset.key = '';
          this.hideQtyPicker();
          return null;
        }

        const updates = {};
        matchingItems.forEach((item) => {
          updates[item.key] = 0;
        });

        return theme.cart.updateItems(updates);
      })
      .then((cartResponse) => {
        if (!cartResponse) return;

        const cart = JSON.parse(cartResponse);
        this.cartItemKey = null;
        this.dataset.key = '';

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        this.hideQtyPicker();
      })
      .catch((err) => {
        console.warn('Cart remove error:', err);
      })
      .finally(() => {
        this.qtyWrapper.classList.remove('is-loading');
        this.isUpdating = false;
      });
  }

  showQtyPicker() {
    this.dataset.inCart = 'true';
  }

  hideQtyPicker() {
    this.dataset.inCart = 'false';

    if (this.qtyInput) {
      this.qtyInput.value = 1;
    }
  }
}

customElements.define('product-form', ProductForm);

class CartRemoveButton extends HTMLElement {
  connectedCallback() {
    this.key = this.dataset.key;
    this.btn = this.querySelector('button');

    if (this.btn) {
      this.btn.addEventListener('click', this.onRemove.bind(this));
    }
  }

  onRemove() {
    this.btn.classList.add('is-loading');
    this.closest('.cart__item').querySelector('.js-qty__wrapper').classList.add('is-loading');

    theme.cart.changeItem(this.key, 0)
      .then(cart => {
        const parsedCart = JSON.parse(cart);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: parsedCart }
        }));

        // Triggers CartForm.buildCart() which rebuilds the drawer HTML
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(err => {
        console.error('Remove item error:', err);
        this.btn.classList.remove('is-loading');
        this.closest('.cart__item').querySelector('.js-qty__wrapper').classList.remove('is-loading');
      });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class DeliveryDatePicker extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.calendarContainer = null;
    this.fp = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.input = this.querySelector("[data-input]");
    this.calendarContainer = this.querySelector(".delivery-date__calendar");

    if (!this.input || !this.calendarContainer) return;

    // 🚨 HARD RESET (this is the real fix)
    this.input.value = "";
    this.input.removeAttribute("value");

    // 💥 Destroy ANY existing instance (global or theme)
    if (this.input._flatpickr) {
      this.input._flatpickr.destroy();
      this.input._flatpickr = null;
    }

    this.initFlatpickr();
    this.setupToggle();
  }

  initFlatpickr() {
    this.fp = flatpickr(this.input, {
      inline: true,
      appendTo: this.calendarContainer,

      dateFormat: "d M Y",
      monthSelectorType: "static",

      // ✅ Correct range
      minDate: new Date().fp_incr(5),
      maxDate: new Date().fp_incr(30),

      onChange: (selectedDates, dateStr) => {
        if (!selectedDates.length) return;

        const date = selectedDates[0];
        this.input.value = dateStr;

        this.dispatchEvent(
          new CustomEvent("delivery:updated", {
            detail: {
              date: dateStr,
              price
            },
            bubbles: true
          })
        );

        this.classList.remove("is-open");
      }
    });
  }

  setupToggle() {
    const toggle = this.querySelector(".delivery-date__toggle");
    if (!toggle) return;

    toggle.addEventListener("click", () => {
      this.classList.toggle("is-open");
    });
  }

  disconnectedCallback() {
    if (this.fp) {
      this.fp.destroy();
    }
  }
}

customElements.define("delivery-date-picker", DeliveryDatePicker);

class AllCategorySection extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.list = null;
  }

  connectedCallback() {
    this.button = this.querySelector(".all-category__list-toggle");
    this.list = this.querySelector(".all-category__list");

    if (!this.button || !this.list) return;

    this.setHeight();
    this.updateButtonText();

    this.button.addEventListener("click", () => this.toggle());
    window.addEventListener("resize", () => this.setHeight());
  }

  setHeight() {
    const height = this.list.scrollHeight;
    this.style.setProperty("--list-height", `${height}px`);

    const firstItem = this.querySelector(".collection-item");
    if (firstItem) {
      const itemHeight = firstItem.offsetHeight;
      this.style.setProperty("--item-height", `${itemHeight}px`);
    }
  }

  toggle() {
    this.classList.toggle("open");
    this.setHeight();
    this.updateButtonText();
  }

  updateButtonText() {
    if (this.classList.contains("open")) {
      this.button.textContent = "Hide all categories";
    } else {
      this.button.textContent = "View all categories";
    }
  }
}

customElements.define("all-category-section", AllCategorySection);

class ClampContent extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('.clamp-content__container');
    const inner = this.querySelector('.clamp-content__inner');
    const btn = this.querySelector('.clamp-content__toggle');

    if (!container || !inner || !btn) return;

    // Measure full height and expose it as the CSS variable
    const fullHeight = inner.scrollHeight;
    this.style.setProperty('--content-height', fullHeight + 'px');

    // Only activate if content overflows the clamped height
    const clampedHeight = parseInt(getComputedStyle(container).maxHeight, 10);
    if (fullHeight <= clampedHeight) return;

    // Show the button (remove the `hidden` attribute/class)
    btn.classList.remove('hide');

    btn.addEventListener('click', () => {
      const isOpen = this.classList.toggle('open');
      btn.textContent = isOpen ? 'Read Less' : 'Read More';
    });
  }
}

customElements.define('clamp-content', ClampContent);